/*
Copyright 2026 Dexnet / iON.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

/*
 * iON (BUGS 210): one duration of a call for everyone — the end screen shows
 * it, and the apps get it in im.vector.hangup as `data.ion_duration_ms` for
 * the call log and the chat preview. It runs from the moment the other side
 * is in the call (as the timer in the header) to the end; 0 if nobody came.
 */

let startedAt: number | null = null;

/** The other side came: the call starts now (only the first time counts). */
export function ionCallAnswered(now = Date.now()): void {
  startedAt ??= now;
}

/** A new call (also "Call back"). */
export function ionCallReset(): void {
  startedAt = null;
}

export function ionCallDurationMs(now = Date.now()): number {
  return startedAt === null ? 0 : Math.max(0, now - startedAt);
}

/** What im.vector.hangup carries to the app. */
export function ionHangupData(): { ion_duration_ms: number } {
  return { ion_duration_ms: ionCallDurationMs() };
}
